import loggingService from '../services/util/loggingService'

var isDebug = false
var path = '/Isolate/'

function get (http, id) {
    return http.get(`${path}Get?isolateId=${id}`)
}

function put (http, dto) {
    return http.put(path, dto)
}

function remove (http, id) {
    return http.delete(`${path}Remove?isolateId=${id}`)
}

function search (http, searchDto) {
    loggingService.log(isDebug, 'Isolate Service', 'Search by ' + searchDto.investigationId)
    return http.post(`${path}Search`, searchDto)
}

function isolateReportGen (http, isolateId) {
    return http.get(path + `IsolateReportGen?isolateId=${isolateId}`, { responseType: 'arraybuffer' })
}

function searchExtended (http, searchDto) {
    loggingService.log(isDebug, 'Isolate Service', 'Search Extended')
    return http.post(`${path}SearchExtended`, searchDto)
}

/**
 * Given a searchDto constraining the isolates, search for all isolates with additional
 * group association information based on the constraining dto
 * @param {HttpContext} http
 * @param {IsolateSearchDto} searchDto the search parameters to constrain isolates
 * @returns a list of isolate association data including things like associate group
 * size and dbi numbers. See the IsolateSearchAssociationDto for complete fields
 */
function searchExtendedAssociations (http, searchDto) {
    loggingService.log(isDebug, 'Isolate Service', 'Search Extended Associations')
    return http.post(`${path}SearchExtendedAssociations`, searchDto)
}

/**
 * Retrieves a list of isolates that have been associated with the parameterized isolate
 * @param {HttpContext} http
 * @param {number} isolateId The id of the isolate record of which to get associated values
 * @returns {IsolateDto[]} The list of isolates
 */
function getAssociatedIsolates (http, isolateId) {
    loggingService.log(isDebug, 'Isolate Service', 'Associated Isolates', 'get')
    return http.get(`${path}GetAssociatedIsolates?isolateId=${isolateId}`)
}

/**
 * Creates an association between the two isolates indicated by the parameterized isolate
 * ids. Since isolate associations are omni-directional, the order here shouldn't matter.
 * @param {HttpContext} http
 * @param {number} baseIsolateId The id of the isolate record currently being viewed
 * @param {number} assocIsolateId The id of the isolate record to associate with the base isolate
 * @returns a ValidationResult object with information on whether the creation of the
 * association succeeded or not
 */
function addAssociatedIsolate (http, baseIsolateId, assocIsolateId) {
    loggingService.log(isDebug, 'Isolate Service', 'Associated Isolates', 'put')
    return http.put(`${path}AddAssociatedIsolate?isolateId=${baseIsolateId}&associatedId=${assocIsolateId}`)
}

/**
 * deleteAssociatedIsolate will remove the parameterized isolate from the association group it
 * is current within. It will also remove the other isolate from the group if it only has two
 * elements in the group prior to invoking this method.
 * @param {HttpContext} http
 * @param {number} assocIsolateId the IsolateId of the isolate to remove from its association group
 * @returns a ValidationResult object indicating the success of the delete operation
 */
function deleteAssociatedIsolate (http, assocIsolateId) {
    loggingService.log(isDebug, 'Isolate Service', 'Associated Isolates', 'delete')
    return http.delete(`${path}RemoveIsolateAssociation?formerAssociatedIsolateId=${assocIsolateId}`)
}

function getLandownerList () {
    return [
        {id: 1, description: 'State'},
        {id: 2, description: 'Federal'},
        {id: 3, description: 'Private'},
        {id: 4, description: 'Multiple'},
        {id: 5, description: 'Unknown'}
    ]
}

export default {
    get: get,
    put: put,
    remove: remove,
    search: search,
    isolateReportGen: isolateReportGen,
    getLandownerList: getLandownerList,
    searchExtended: searchExtended,
    searchExtendedAssociations: searchExtendedAssociations,
    getAssociatedIsolates: getAssociatedIsolates,
    addAssociatedIsolate: addAssociatedIsolate,
    deleteAssociatedIsolate: deleteAssociatedIsolate
}



// WEBPACK FOOTER //
// ./src/services/isolateService.js